import TecdocSubCategories from '@/pages/tecdoc/subcategories'
import React from 'react'

const ManagementCatalogSubCategories = () => {
  return (
    <div>
    <TecdocSubCategories />
    </div>
  )
}

export default ManagementCatalogSubCategories